import { DesignSearchResponse, ShopDesignSearchParams } from '@/types';
import { convertSprdLocaleToSprdIsoLocale } from '@/utils/convertSprdLocaleToIsoLocale';
import { getParams } from '@/utils/params';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';
import { addParamsToUrl } from './methods/urlParams';

export const fetchShopDesigns = (params: ShopDesignSearchParams, signal?: AbortSignal) =>
  requestToJSON<DesignSearchResponse>(
    getRequest(
      addParamsToUrl(
        `/search/omat/${convertSprdLocaleToSprdIsoLocale(
          getParams().searchLocale || getParams().locale
        )}/shop/${getParams().contextId}/designs`,
        params
      ),
      {
        signal,
      }
    )
  );
